export class FaltaMatriculadoConsolidado {
  pessoaId?: string;
  pessoaNome?: string;
  /** Celular cadastrado (ex.: para wa.me). */
  pessoaTelefone?: string | null;
  totalFaltas = 0;
  /** Última data com registro de frequência na turma (ISO yyyy-MM-dd). */
  dataUltimoRegistro?: string;
  faltouUltimoEncontro = false;

  constructor(data?: Partial<FaltaMatriculadoConsolidado>) {
    if (data) Object.assign(this, data);
  }
}

export class FrequenciaFaltasConsolidado {
  turmaId?: string;
  turmaNome?: string;
  frequenciaMissa = false;
  matriculados?: FaltaMatriculadoConsolidado[];

  constructor(data?: Partial<FrequenciaFaltasConsolidado>) {
    if (data) Object.assign(this, data);
  }
}
